import { z } from "zod";
import { GroupReference } from "./group";
export const BaseAnalyticsEvent = z.object({
    group: GroupReference.optional()
});
